var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBlackRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 203.33 47.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #000;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #ff003d;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Art"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M77.51,47.4c-6.89.05-12.02-1.53-15.4-4.74-3.38-3.21-5.09-7.96-5.14-14.26l-.18-24.08,10.92-.08.18,24.15c.02,3.27.81,5.75,2.37,7.43,1.56,1.69,3.95,2.52,7.17,2.5,3.25-.02,5.63-.89,7.17-2.6,1.53-1.71,2.29-4.2,2.27-7.47l-.18-24.15,10.92-.08.18,24.08c.05,6.29-1.59,11.07-4.91,14.33-3.32,3.26-8.45,4.91-15.38,4.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M102.04,46.03l-.23-31.98,10.66-.08-.33,9.08.44,1.02.16,21.88-10.69.08ZM126.25,45.86l-.13-17.37c0-1.27-.2-2.42-.57-3.43-.37-1.02-1.01-1.82-1.93-2.4s-2.18-.87-3.81-.86c-1.36,0-2.53.24-3.52.68-.98.45-1.8,1.04-2.45,1.78-.65.74-1.16,1.56-1.53,2.46l-1.42-5.12h1.65c.36-1.62,1.01-3.06,1.94-4.35.93-1.29,2.22-2.32,3.86-3.09,1.64-.77,3.7-1.16,6.18-1.18,2.76-.02,5.04.47,6.84,1.48,1.79,1.01,3.14,2.5,4.03,4.48.89,1.98,1.35,4.43,1.37,7.34l.14,19.51-10.66.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M146.03,10.38c-2,.01-3.46-.41-4.39-1.28-.93-.87-1.4-2.06-1.41-3.58v-.2c-.01-1.49.44-2.68,1.35-3.58.92-.89,2.37-1.35,4.37-1.36,1.97-.01,3.43.42,4.37,1.3.94.88,1.41,2.07,1.42,3.56v.2c.01,1.54-.45,2.74-1.37,3.61-.93.87-2.38,1.32-4.35,1.33ZM140.96,45.75l-.23-31.98,10.66-.08.23,31.98-10.66.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M152.83,45.66l11.38-18.05.02,2.7-11.31-16.63,11.88-.09,6.79,10.81h.69s6.63-10.91,6.63-10.91l11.84-.09-11.06,16.79-.02-2.7,11.64,17.88-11.91.09-7.06-11.4h-.69s-6.92,11.5-6.92,11.5l-11.91.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M197.61,10c-2,.01-3.46-.41-4.39-1.28-.93-.87-1.4-2.06-1.41-3.58v-.2c-.01-1.49.44-2.68,1.35-3.58.92-.89,2.37-1.35,4.37-1.36,1.97-.01,3.43.42,4.37,1.3.94.88,1.41,2.07,1.42,3.56v.2c.01,1.54-.45,2.74-1.37,3.61-.93.87-2.38,1.32-4.35,1.33ZM192.54,45.37l-.23-31.98,10.66-.08.23,31.98-10.66.08Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 0,
    width: 47.36,
    height: 47.36,
    rx: 6.33,
    ry: 6.33
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "28.12 30.2 25.25 31.5 25.25 31.58 28.12 32.84 28.12 35.97 23.7 33.3 19.23 36.01 19.23 32.79 22.07 31.56 22.07 31.5 19.23 30.13 19.23 27 23.7 29.8 28.12 27.03 28.12 30.2"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 19.23,
    y: 37.44,
    width: 8.89,
    height: 2.73
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 19.23,
    y: 22.84,
    width: 8.89,
    height: 2.73
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M12.73,14.18c0-.85.11-1.62.33-2.29.22-.67.52-1.25.92-1.74.4-.49.88-.89,1.44-1.21s1.19-.56,1.89-.72c.7-.16,1.46-.24,2.28-.24h3.03v3.63h-2.83c-.85,0-1.54.11-2.04.34-.51.22-.87.53-1.09.91-.22.38-.33.82-.33,1.31s.11.95.33,1.34c.21.38.58.68,1.08.91s1.18.34,2.05.34h2.83v3.63h-3.03c-2.17,0-3.86-.52-5.06-1.57-1.2-1.05-1.8-2.59-1.8-4.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M34.31,16.49c-.22.67-.53,1.25-.93,1.74-.4.49-.88.89-1.44,1.21-.56.32-1.19.56-1.89.72-.7.15-1.46.23-2.28.23h-3.03v-3.63h2.83c.85,0,1.53-.11,2.04-.34s.87-.52,1.09-.91c.21-.38.32-.82.32-1.31s-.11-.95-.32-1.33c-.22-.38-.58-.68-1.08-.91-.5-.22-1.19-.34-2.05-.34h-2.83v-3.63h3.03c2.17,0,3.86.52,5.06,1.57,1.2,1.05,1.8,2.59,1.8,4.64,0,.85-.11,1.62-.32,2.29Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlackRed);
export default __webpack_public_path__ + "static/media/logo-black-red.27fcc820899777b209498f6d508b0085.svg";
export { ForwardRef as ReactComponent };